export default __webpack_public_path__ + "static/media/ra-love-c.1bc4a2dd.svg";